import { storefront } from './sections/storefront.en-courses';
import { account } from './sections/account.en-courses';
import { admin } from './sections/admin.en-courses';

export const en = { ...storefront, ...account, ...admin };
